<div id="preloader">
        <img src="assets/media/logos/etec-OI.svg" width="65" />
        <div id="loader"></div>
 </div>
